import { GenericService, Service } from "./genericService";
import axios from "axios";
import Report from '../models/Report';

class ReportService extends GenericService<Report> implements Service<Report> {
  constructor() {
    super("api/Report");
  }

  report = async (userId: string): Promise<void> => {
    await axios.post(`${this.baseUrl}/report`, {
      userId
    });
  };
}

export default new ReportService();
